import ViewModal from "./view-modal";
import RequestService from "./request-service";
import Utils from "./utils";
import AppointmentsService from "./appointments-service";

export default class LoginModal extends ViewModal {
  #title;

  constructor(linkInterceptor) {
    super(linkInterceptor);
    this.#title = "Please login or register";
  }

  async open() {
    this.handleLinks("/Account/Register", "/Account/Login", "/Account/ForgotPassword");

    await super.open(this.#title);
    this.onSetContent(this.#interceptSubmit);
    await this.setContentOnLoad(AppointmentsService.getLoginContent());
  }

  async requestLogin() {
    await this.open();

    try {
      await this.#awaitLoginSuccess();
    } catch (error) {
      if (error.message === "Aborted") {
        error.message = "Login cancelled.";
      }

      throw error;
    } finally {
      await this.close();
    }

    // Login success
  }

  #interceptSubmit() {
    $("form").off("submit").on("submit", async (e) => {
      e.preventDefault();

      const $form = $(e.currentTarget);

      const contentPromise = RequestService.post(`${$form.attr("action")}Content`, $form.serialize());
      await this.setContentOnLoad(contentPromise);
    });
  }

  async #awaitLoginSuccess() {
    return Utils.promisifyEvent(document, "login-success", this.abortController.signal);
  }
}
